import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

console.log(environment.googlecode);

if (environment.googlecode.startsWith('G-')) {  
  console.log('Load new google code analytics')
  var s = document.createElement('script');
  s.type = 'text/javascript';
  var code =  "window.dataLayer = window.dataLayer || [];"+
              "function gtag(){dataLayer.push(arguments);}"+
              "gtag('js', new Date());";
  try {
    s.appendChild(document.createTextNode(code));
    document.body.appendChild(s);
  } catch (e) {
    s.text = code;
    document.body.appendChild(s);
  }

  let node = document.createElement('script');
  node.src = "https://www.googletagmanager.com/gtag/js?id=" + environment.googlecode;
  node.async = true;
  document.getElementsByTagName('head')[0].appendChild(node);

  (<any>window).gtag('config', environment.googlecode, {
    cookie_flags: 'max-age=7200;secure;samesite=none',
    'send_page_view': false
  });
}

if (environment.googlecode.startsWith('UA')) {
  console.log('Load old google code analytics');
  (function(i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function() {
        (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = new Date();
    a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  (<any>window).ga('create', environment.googlecode, {
    cookieFlags: 'max-age=7200;secure;samesite=none'
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts